module.exports = __webpack_public_path__ + "img/6.29ab11b6.jpg";